const Code = Object.freeze({
  AR: 'ar_AE',
  EN: 'en_GB',
});

export default Code;
